import { useRoute as useVueRoute } from 'vue-router'

export function useRoute() {
  const route = useVueRoute()

  return route
}
